import { render, staticRenderFns } from "./i-paginator.vue?vue&type=template&id=795478b4&scoped=true&"
import script from "./i-paginator.vue?vue&type=script&lang=js&"
export * from "./i-paginator.vue?vue&type=script&lang=js&"
import style0 from "./i-paginator.vue?vue&type=style&index=0&id=795478b4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795478b4",
  null
  
)

export default component.exports